<template>
  <div class="cs-garage">
    <div class="background-top"></div>
    <div class="cs-garage-header">
      <div class="user-avatar">
        <v-avatar color="primary" size="48">
          <v-img :src="require('@/assets/profile_default.png')" />
        </v-avatar>
      </div>
      <div class="user-details">
        <div class="name">{{ user ? user.name : 'Não autenticado(a)' }}</div>
        <div class="phone">{{ user ? user.phone : 'Faça login ou cadastre-se...' }}</div>
      </div>
      <div class="user-actions">
        <v-icon :disabled="!user" color="#3e515f" size="28px" @click="isModalEditUserOpen = true">mdi-pencil-circle-outline</v-icon>
        <v-icon @click="$emit('logout')" color="#3e515f" size="30px">mdi-power</v-icon>
      </div>
    </div>
    <div class="cs-garage-statics">
      <div class="statistic">
        <div class="value">{{ user_vehicles && user_vehicles.services ? user_vehicles.services : '-' }}</div>
        <div class="description">Serviços</div>
      </div>
      <div class="statistic">
        <div class="value">{{ user_vehicles && user_vehicles.evaluations ? user_vehicles.evaluations : '-' }}</div>
        <div class="description">Avaliações</div>
      </div>
      <div class="statistic">
        <div class="value">{{ user_vehicles && user_vehicles.schedules ? user_vehicles.schedules : '-' }}</div>
        <div class="description">Agendamentos</div>
      </div>
    </div>
    <div v-if="!user" class="cs-garage-content">
      <div class="no-vehicles">
        <v-img contain style="height: 110px; filter: grayscale(1); margin-bottom: 13px" :src="require('@/assets/vehicle-checklist.png')" />
        <h3>Faça login ou cadastre-se grátis!</h3>
        <small>Visualize aqui todos os relatórios do seu veículo feitos por oficinas que utilizam o <b>CheckMotors</b>.</small>
      </div>
    </div>
    <div v-else class="cs-garage-content">
      <v-alert dense text border="left" color="primary" style="font-size: 12px; padding-right: 9px; text-align: center">
        Confira abaixo todas as ordens de serviço e veículos cadastrados por oficinas que utilizam o aplicativo de checklist <b>CheckMotors</b>.
      </v-alert>
      <div v-if="user_vehicles && user_vehicles.vehicles">
        <div class="separator">
          <v-divider></v-divider>
          <div class="label">Meus Veículos</div>
        </div>
        <div v-for="vehicle in user_vehicles.vehicles" :key="vehicle.id" @click="openModalVehicle(vehicle)" class="vehicle">
          <div class="vehicle-cover">
            <v-img
              v-if="vehicle.vehicle_cover"
              :src="vehicle.vehicle_cover"
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
              height="200px"
            >
              <v-list-item class="px-3 white--text" style="text-transform: uppercase; text-align: center; justify-content: center">
                {{ vehicle.vehicle_brand && vehicle.vehicle_brand.description ? vehicle.vehicle_brand.description : '' }}
                {{ vehicle.description }}
              </v-list-item>
            </v-img>
            <v-img
              v-else
              :src="require('@/assets/car_thumbnails/car-photo-01.jpg')"
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
              height="200px"
              :contain="true"
            ></v-img>
          </div>
          <div class="vehicle-details">
            <table>
              <tr>
                <td style="width: 65px">
                  <img v-if="vehicle.vehicle_brand && vehicle.vehicle_brand.logo_url" :src="vehicle.vehicle_brand.logo_url" />
                </td>
                <td style="padding-top: 3px">
                  <div class="value">{{ vehicle.year }}/{{ vehicle.year_model }}</div>
                  <div class="description">Ano/Modelo</div>
                </td>
                <td style="padding-top: 3px">
                  <div class="value">{{ vehicle.total_services }}</div>
                  <div class="description">Serviços</div>
                </td>
                <td style="width: 105px">
                  <img v-if="vehicle.vehicle_plate_photo_url" :src="vehicle.vehicle_plate_photo_url" height="95px" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-else>
        <v-skeleton-loader v-for="i in 2" :key="i" class="mb-7" type="card" elevation="1"></v-skeleton-loader>
      </div>
    </div>

    <VehicleModal :is-active="dialog_vehicle.status" :vehicle="dialog_vehicle.vehicle" @close="closeModalVehicle" />

    <UserEditModal :is-active="isModalEditUserOpen" @close="isModalEditUserOpen = false" @save="isModalEditUserOpen = false" />
  </div>
</template>

<script>
import UserEditModal from './GarageTab/UserEditModal';
import VehicleModal from './GarageTab/VehicleModal';

export default {
  components: { VehicleModal, UserEditModal },
  emits: ['logout'],
  data() {
    return {
      user_vehicles: null,
      dialog_vehicle: {
        status: false,
        vehicle: null
      },
      isModalEditUserOpen: false
    };
  },
  computed: {
    user() {
      return this.$store.getters['Auth/user'];
    }
  },
  mounted() {
    this.getVehicles();
  },
  methods: {
    getVehicles() {
      const self = this;
      self.$http.get('/user/garage').then((response) => {
        self.user_vehicles = response.data;
      });
    },
    openModalVehicle(vehicle) {
      this.dialog_vehicle.vehicle = vehicle;
      this.dialog_vehicle.status = true;
    },
    closeModalVehicle() {
      this.dialog_vehicle.vehicle = null;
      this.dialog_vehicle.status = false;
    }
  }
};
</script>

<style scoped lang="scss">
.cs-garage {
  height: inherit;

  .background-top {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 115px;
    background-color: #f1f1f1;
    content: ' ';
  }

  .cs-garage-statics {
    background-color: #fff;
    z-index: 10;
    top: 0px;
    position: fixed;
    width: -webkit-fill-available;
    margin: 83px 20px 10px 20px;
    border-radius: 10px;
    padding: 10px 15px;
    border: 2px solid #eee;
    text-transform: uppercase;

    .statistic {
      color: #3e515f;
      float: left;
      width: 33%;
      text-align: center;

      &:nth-child(2) {
        border-left: 1px solid #eee;
        border-right: 1px solid #eee;
      }

      .value {
        font-weight: bold;
        font-size: 17px;
      }

      .description {
        font-size: 10px;
      }
    }
  }

  .cs-garage-header {
    overflow: hidden;
    z-index: 10;
    top: 0px;
    position: fixed;
    width: -webkit-fill-available;
    margin: 20px;

    .user-avatar {
      width: 13%;
      overflow: hidden;
      float: left;
    }

    .user-details {
      width: 60%;
      float: left;
      padding-left: 15px;
      padding-top: 4px;
      color: #3e515f;
      line-height: 20px;

      .name {
        font-size: 17px;
        font-weight: bold;
      }

      .phone {
        font-size: 13px;
      }
    }

    .user-actions {
      display: flex;
      width: 27%;
      padding-top: 8px;

      .v-icon {
        font-size: 28px;
        float: right;
        margin-left: 13px;

        &:first-child {
          border-left: 1px solid #cecece;
          padding-left: 13px;
        }
      }
    }
  }

  .cs-garage-content {
    margin: 165px 20px 80px 20px;
    width: -webkit-fill-available;
    height: inherit;

    .no-vehicles {
      margin-top: 20%;
      text-align: center;
    }

    .vehicle {
      width: 100%;
      border-radius: 10px;
      box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);
      overflow: hidden;
      margin-bottom: 23px;
      margin-top: 4px;

      .vehicle-details {
        table {
          width: 100%;
          border-radius: 5px;
          text-transform: uppercase;
          padding: 3px 5px;

          tr {
            text-align: center;

            td {
              border: 1px solid #d9d9d9;
              padding-top: 6px;
              border-radius: 4px;
              color: #3e515f;

              img {
                height: 30px;
              }

              .value {
                font-weight: bold;
                font-size: 15px;
                line-height: 15px;
              }

              .description {
                font-size: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
